/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { DeleteOneBaseAodRulesControllerAodRuleMutationResponse, DeleteOneBaseAodRulesControllerAodRulePathParams } from "../models/DeleteOneBaseAodRulesControllerAodRule";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteOneBaseAodRulesControllerAodRule } from "../axios/deleteOneBaseAodRulesControllerAodRule";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteOneBaseAodRulesControllerAodRuleMutationKey = () => ["audit-reports-api", { url: '/aod-rules/:id' }] as const

export type DeleteOneBaseAodRulesControllerAodRuleMutationKey = ReturnType<typeof deleteOneBaseAodRulesControllerAodRuleMutationKey>

export function deleteOneBaseAodRulesControllerAodRuleMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteOneBaseAodRulesControllerAodRuleMutationKey()
        return mutationOptions<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteOneBaseAodRulesControllerAodRule(id, config)
          },
        })

}

/**
 * @summary Delete a single AodRule
 * {@link /aod-rules/:id}
 */
export function useDeleteOneBaseAodRulesControllerAodRule<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteOneBaseAodRulesControllerAodRuleMutationKey()

          const baseOptions = deleteOneBaseAodRulesControllerAodRuleMutationOptions(config) as UseMutationOptions<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]}, TContext>
          

          return useMutation<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]}, TContext>
      
}